export default {
  profile: 'Perfil',
  logout: 'Cerrar sesión',
  selectProfiles: 'Selección de perfiles'
}
